module.exports = __webpack_public_path__ + "img/feature_1.d0b1fcf8.jpg";